var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClimbing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79999 4.85387C4.79999 4.57772 5.02385 4.35387 5.29999 4.35387H18.8C19.0761 4.35387 19.3 4.57772 19.3 4.85387V19.2539C19.3 19.53 19.0761 19.7539 18.8 19.7539H5.29999C5.02385 19.7539 4.79999 19.53 4.79999 19.2539V4.85387ZM5.79999 5.35387V18.7539H18.3V5.35387H5.79999Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 19.2539C3 18.9777 3.22386 18.7539 3.5 18.7539H20.5C20.7761 18.7539 21 18.9777 21 19.2539V20.5539C21 20.83 20.7761 21.0539 20.5 21.0539H3.5C3.22386 21.0539 3 20.83 3 20.5539V19.2539ZM4 19.7539V20.0539H20V19.7539H4Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70001 12.0539C9.70001 11.7777 9.92387 11.5539 10.2 11.5539H12C12.2762 11.5539 12.5 11.7777 12.5 12.0539C12.5 12.33 12.2762 12.5539 12 12.5539H10.2C9.92387 12.5539 9.70001 12.33 9.70001 12.0539Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8 16.5539C12.8 16.2777 13.0238 16.0539 13.3 16.0539H15.1C15.3761 16.0539 15.6 16.2777 15.6 16.5539C15.6 16.83 15.3761 17.0539 15.1 17.0539H13.3C13.0238 17.0539 12.8 16.83 12.8 16.5539Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70001 7.85387C7.70001 7.57772 7.92387 7.35387 8.20001 7.35387H10C10.2762 7.35387 10.5 7.57772 10.5 7.85387C10.5 8.63001 9.87616 9.25387 9.10001 9.25387C8.32387 9.25387 7.70001 8.63001 7.70001 7.85387Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7 9.65387C13.7 9.37773 13.9239 9.15387 14.2 9.15387H16C16.2762 9.15387 16.5 9.37773 16.5 9.65387C16.5 10.43 15.8762 11.0539 15.1 11.0539C14.3239 11.0539 13.7 10.43 13.7 9.65387Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90002 15.0539C7.90002 14.7777 8.12388 14.5539 8.40002 14.5539H10.2C10.4762 14.5539 10.7 14.7777 10.7 15.0539C10.7 15.83 10.0762 16.4539 9.30002 16.4539C8.95282 16.4539 8.59724 16.3491 8.32338 16.0963C8.04296 15.8374 7.90002 15.471 7.90002 15.0539Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClimbing);
export default __webpack_public_path__ + "static/media/climbing.81dbe61ffcbe3226b8177bb4b6857cfc.svg";
export { ForwardRef as ReactComponent };